import { render, staticRenderFns } from "./LecturaExcel.vue?vue&type=template&id=3934b424&scoped=true&"
import script from "./LecturaExcel.vue?vue&type=script&lang=ts&"
export * from "./LecturaExcel.vue?vue&type=script&lang=ts&"
import style0 from "./LecturaExcel.vue?vue&type=style&index=0&id=3934b424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3934b424",
  null
  
)

export default component.exports